var exports = {
  "yw": "searchButtonGroup__lia0l0",
  "UL": "smallSearchButton__L5sFt_",
  "JU": "searchButton__6Ru-S-",
  "Ao": "searchPage__p4GDVc",
  "eS": "kbd__Qnh9QU",
  "qf": "placeholder__MIdoN6",
  "Qq": "text__t7BSCl",
  "Uq": "value__JUFO_5",
};

module.exports = exports;
